import * as React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import styled, { css } from "styled-components";
import ListItem from "./ListItem";
const StyledListItem = styled(ListItem)(
  ({ $isDragging, $transform, $transition }) => css`
    transform: ${CSS.Transform.toString($transform)};
    transition: ${$transition};
    opacity: ${$isDragging ? 0.6 : 1};
  `
);
const SortableListItem = ({
  alignItemContent = void 0,
  className = void 0,
  customContentRender = void 0,
  customListItemRender = void 0,
  disableDragging = false,
  index,
  item
}) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: item.id });
  return /* @__PURE__ */ React.createElement(
    StyledListItem,
    {
      $isDragging: isDragging,
      $transform: transform,
      $transition: transition,
      alignItemContent,
      className,
      customContentRender,
      customListItemRender,
      disableDragging,
      dragHandleProps: { ...attributes, ...listeners },
      index,
      item,
      isDragging,
      ref: setNodeRef
    }
  );
};
export default SortableListItem;
